export default __webpack_public_path__ + "9858ba64970f7343439a147c147bdf3a.svg";